import {Injectable, isDevMode} from '@angular/core'
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {IPagin} from './IPaginator-model';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {UrlsResources} from "../urls-resources";
import { HandleError } from '../handle-error';

@Injectable()
export class PaginationService {

  private options = {
    headers: new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8')
  };

  constructor(private http: HttpClient,
    private handleError: HandleError,
    private urlsResources: UrlsResources) {
  }

  buildUrl(data: IPagin) {
    let endPoint = data.endPoint ?
      data.endPoint : this.urlsResources.getPayments();

    return `${endPoint}${data.path}?size=${data.size}&page=${data.page}`;
  }

  getDataToPaginator(data: IPagin): Observable<any> {

    return this.http.get(this.buildUrl(data), { withCredentials: true })
      .map(result => {
        if (isDevMode()) {
          console.log(' [ PaginatorService] :: [getDataToPaginator] :::::');
          console.log(result);
        }
        return result;
      })
      .catch(error => this.handleError.handleErrorAsObservable(error));

  }

  getPaymentsByStatus(data: any): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('size', data.size);
    params = params.append('page', data.page);
    params = params.append('status', data.status);

    const options = {params: params, withCredentials: true};
    const url = this.urlsResources.getPayments() + data.path;
    return this.http.get(url, options).catch(error => this.handleError.handleErrorAsObservable(error));
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/pagination/paginator.service.ts